import { Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const UserDetailWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const UserDetail = styled.div`
  flex: 1.7;

  .item-body {
    padding: 16px 0;
  }
`;

const HeaderGroup = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 16px;
`;

const AppreciationsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
`;

const AppreciationDetail = styled.div``;

const FeatureBox = styled.div``;

const FeatureBody = styled.div`
  align-items: flex-start;
  align-self: stretch;
  background: var(--color-bg-weaker);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-6);
  padding: var(--size-padding-12);
`;

const AppreciationItem = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  width: 100%;
`;

const InfoHeaderWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SettingInput = styled(Input)`
  cursor: not-allowed;
`;

export {
  AppreciationDetail,
  AppreciationItem,
  AppreciationsWrapper,
  FeatureBody,
  FeatureBox,
  FormContent,
  HeaderGroup,
  InfoHeaderWrapper,
  SettingInput,
  UserDetail,
  UserDetailWrapper
};
